import React from 'react';
import { Box } from '@mui/material';
import DashboardSourcePicker from 'c-dashboard-module/DashboardSourcePicker';
import type { SummarySource } from './useSummarySources';

const SUMMARY_KIND_LABELS: Record<string, string> = { default: 'Built in' };

type Props = {
    sources: SummarySource[];
    activeKey: string;
    activeName: string;
    onSelect: (key: string) => void;
};

/**
 * Which summary is showing, centred under the Summary tab, and a picker to switch between the
 * built-in summary and any assigned to the viewer. With none assigned there is nothing to switch
 * to, so it isn't shown and the Summary reads exactly as it always has.
 */
const SummarySwitcher: React.FC<Props> = ({ sources, activeKey, activeName, onSelect }) => {
    if (sources.length < 2) return null;

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                border: 1,
                borderColor: 'divider',
                borderRadius: 4,
                bgcolor: 'background.paper',
                pl: 1.5,
                pr: 0.5,
                py: 0.25,
                fontSize: '0.8rem',
            }}
        >
            <DashboardSourcePicker
                sources={sources}
                activeKey={activeKey}
                onSelect={onSelect}
                noun="summary"
                nounPlural="summaries"
                kindLabels={SUMMARY_KIND_LABELS}
            >
                <Box component="span" sx={{ color: 'text.secondary', mr: 0.5 }}>
                    Viewing
                </Box>
                <Box
                    component="span"
                    sx={{
                        maxWidth: 220,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        fontWeight: 600,
                    }}
                >
                    {activeName}
                </Box>
            </DashboardSourcePicker>
        </Box>
    );
};

export default SummarySwitcher;
